import { Calendar } from '@fullcalendar/core';
import { CalendarOptions } from "@fullcalendar/core";
import { getViewTimeLine } from './getView';
import { getTimeLineOptions } from './timelineOptions';
import { TimeLineFilterManager } from './FilterManager/timeLineFilterManager';
import { luscinia } from '../luscinia';

const agendaEl = document.getElementById('luscinia-timeline') as HTMLDivElement;

function observeDOMChanges() {
    const observer = new MutationObserver(() => {
        removeLicenseMessage();
    });

    observer.observe(document, {
        childList: true,
        subtree: true
    });
}

function removeLicenseMessage() {
    document.querySelectorAll('.fc-license-message').forEach(element => {
        element.remove();
    });
}

if (agendaEl !== null) {
    const calendar = new Calendar(agendaEl, getTimeLineOptions(agendaEl));
    calendar.setOption('windowResize', function (info) {
        calendar.changeView(getViewTimeLine(window.innerWidth));
    });

    var startDate;
    var endDate;
    var newSaved;
    var newSavedId;
    calendar.setOption('datesSet', function (dateInfo) {
        startDate = dateInfo.startStr;
        endDate = dateInfo.endStr;
        const detail = {
            start: startDate,
            end: endDate
        };
        const event = new CustomEvent('viewDatesChanged', { detail });
        document.dispatchEvent(event);
    });
    calendar.setOption('eventsSet', function (agendaEvents) {
        if (agendaEvents.length != 0) {
            const event = new CustomEvent('agendaEventsSet');
            document.dispatchEvent(event);

            if (newSaved) {
                var eventAdded = agendaEvents.find(x => x.id == newSavedId)
                if (eventAdded != undefined) {
                    const detail = {
                        start: eventAdded.startStr,
                        end: eventAdded.endStr
                    };
                    const eventDate = new CustomEvent('eventAdded', { detail });
                    document.dispatchEvent(eventDate);
                }
                newSaved = false;
            }
        }
    });

    document.addEventListener('changeTimelineTime', function (event: Event) {
        const customEvent = event as CustomEvent<any>;
        const minTime = customEvent.detail.minTime;
        const maxTime = customEvent.detail.maxTime;
        calendar.setOption('slotMinTime', minTime);
        calendar.setOption('slotMaxTime', maxTime);
    });

    if (luscinia.isMachineTestEnvironment()) {
        // Expose the timeline calendar instance so E2E tests can trigger a date selection through the
        // FullCalendar API (calendar.select(...)) instead of a synthetic drag. Driving the resource
        // timeline's drag-select with automated pointer events is unreliable (it only intermittently
        // meets FullCalendar's select threshold); calling the API fires the same `select` handler
        // deterministically. Test-only - guarded by the machine-test-environment marker.
        (window as any).__lusciniaTimelineCalendar = calendar;
    }

    if (luscinia.isMachineTestEnvironment()) {
        // Fetch the current date from the backend
        fetch('/test/current-date')
            .then(response => response.json())
            .then(data => {
                if (data.currentTime) {
                    const currentDate = new Date(data.currentTime);

                    // Update the current date highlight (now)
                    calendar.setOption('now', currentDate);
                    // Navigate to the current date
                    calendar.gotoDate(currentDate);
                }
            })
            .catch(error => {
                console.error('Error fetching current date:', error);
            });
    }

    calendar.setOption('eventChange', function (agendaEvents) {
        var oldEventStarDate = agendaEvents.oldEvent.startStr;
        var oldEventEndDate = agendaEvents.oldEvent.endStr;
        var newEventStarDate = agendaEvents.event.startStr;
        var newEventEndDate = agendaEvents.event.endStr;

        const detail = {
            oldEventStarDate: oldEventStarDate,
            oldEventEndDate: oldEventEndDate,
            newEventStarDate: newEventStarDate,
            newEventEndDate: newEventEndDate
        };

        const event = new CustomEvent('eventChange', { detail });
        document.dispatchEvent(event);
    });

    document.addEventListener('viewDates', function (event) {
        const detail = {
            start: startDate,
            end: endDate
        };
        const eventDate = new CustomEvent('viewDatesChanged', { detail });
        document.dispatchEvent(eventDate);
    });

    document.addEventListener('refetchEvents', function (event) {
        calendar.refetchEvents();
    });

    document.addEventListener('refetchAll', function (event) {
        calendar.refetchEvents();
        calendar.render();
        calendar.updateSize();

        //Added to fix bug in vanhaandelmetaal where agenda title is displayed twice
        const detail = {
            start: startDate,
            end: endDate
        };
        const eventDate = new CustomEvent('viewDatesChanged', { detail });
        document.dispatchEvent(eventDate);
    });


    document.addEventListener('changeTimeLineDuration', function (event: Event) {
        const customEvent = event as CustomEvent<any>;
        const newDuration = parseInt(customEvent.detail.timeLineDuration);
        changeSlotDuration(newDuration);
    });

    document.addEventListener("ChangeTimelineOption", (event) => {
        const e = event as CustomEvent<{ option: keyof CalendarOptions; value: any }>;
        calendar.setOption(e.detail.option, e.detail.value);
    });

    function changeSlotDuration(newDuration) {
        calendar.setOption('slotDuration', { minute: newDuration });
    }

    calendar.render();
    removeLicenseMessage();
    observeDOMChanges();

    ['recordDeleted', 'recordSaved'].forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
            const customEvent = event as CustomEvent;
            if (event.type == "recordDeleted") {
                var events = calendar.getEvents();
                var deletedEventId = customEvent.detail.id;
                var deletedEvent = events.find(x => x.id == deletedEventId)
                const detail = {
                    start: deletedEvent.startStr,
                    end: deletedEvent.endStr
                };
                const eventDate = new CustomEvent('eventDeleted', { detail });
                document.dispatchEvent(eventDate);
                calendar.refetchEvents();
            }
            else {
                newSaved = true;
                newSavedId = customEvent.detail.id;
                calendar.refetchEvents();
            }
        });
    });

    const filterContainer = document.getElementById('filter-container');
    if (filterContainer != null) {
        const filterManager = new TimeLineFilterManager(filterContainer, calendar);
        filterManager.init();
    }
}
